function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.249 7.207l10.984 12.471a1.066 1.066 0 0 0 1.539 0L23.751 7.207a.987.987 0 0 0-.107-1.414l-1.85-1.557a1.028 1.028 0 0 0-1.438.111L12.191 13.8a.25.25 0 0 1-.379 0L3.644 4.346A1.021 1.021 0 0 0 2.948 4a1 1 0 0 0-.741.238L.356 5.793A.988.988 0 0 0 0 6.478a.978.978 0 0 0 .249.729z"
});

var SvgArrowButtonDownBold = function SvgArrowButtonDownBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgArrowButtonDownBold;